module.exports = __webpack_public_path__ + "static/media/12.7f2f9b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/12.png
// module id = 864
// module chunks = 0